<template>
    <div>
        <div class="d-flex align-items-end flex-wrap flex-gap-4">
            <base-input
                v-model="couponData.couponId"
                :label="$t('eventRegistration.payment.couponNumber')"
                no-margin />

            <div>
                <label class="form-control-label">{{ $t('eventRegistration.payment.couponCode') }}</label>
                <div class="d-flex align-items-center flex-gap-2">
                    <base-input
                        v-model="couponData.word1"
                        :name="$t('eventRegistration.payment.couponCode')"
                        no-margin />
                    <span>-</span>
                    <base-input
                        v-model="couponData.word2"
                        :name="$t('eventRegistration.payment.couponCode')"
                        no-margin />
                    <span>-</span>
                    <base-input
                        v-model="couponData.word3"
                        :name="$t('eventRegistration.payment.couponCode')"
                        no-margin />
                </div>
            </div>

            <base-button
                :disabled="checkingCouponCode"
                @click="redeemCouponCode">
                <template v-if="checkingCouponCode">
                    <span>{{ $t('eventRegistration.payment.checkingCoupon') }}</span>
                    <font-awesome-icon
                        icon="circle-notch"
                        spin />
                </template>
                <template v-else>
                    {{ $t('eventRegistration.payment.redeemCoupon') }}
                </template>
            </base-button>
        </div>
        <div
            class="invalid-feedback"
            style="display: block">
            <span v-if="fillAllFieldsWarning">
                {{ $t('eventRegistration.payment.pleaseFillAllFields') }}
            </span>
            <span v-else-if="couponError === 'couponNotFound'">
                {{ $t('eventRegistration.payment.invalidCouponCode') }}
            </span>
            <span v-else-if="couponError === 'couponIsIncompatibleWithEvent'">
                {{ $t('eventRegistration.payment.couponIsIncompatibleWithEvent') }}
            </span>
            <span v-else-if="couponError === 'alreadyRedeemedCouponCode'">
                {{ $t('eventRegistration.payment.alreadyRedeemedCouponCode') }}
            </span>
        </div>
    </div>
</template>

<script>
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";

export default {
    name: "AddCoupon",
    mixins: [mainRegistrationMixin],
    data() {
        return {
            couponData: {
                couponId: "",
                word1: "",
                word2: "",
                word3: ""
            },
            fillAllFieldsWarning: false,
            couponError: null,
            checkingCouponCode: false
        }
    },
    methods: {
        redeemCouponCode() {
            if (!(this.couponData.couponId && this.couponData.word1 && this.couponData.word2 && this.couponData.word3))
                this.fillAllFieldsWarning = true
            else
                this.checkCouponCode()
        },
        async checkCouponCode() {
            this.checkingCouponCode = true
            await this.sendCheckCouponRequest()
            this.checkingCouponCode = false
        },
        async sendCheckCouponRequest() {
            try {
                const response = await this.$axios.post(this.$apiRoute('api.registration.checkCoupon'),
                                                        {
                                                            ...this.couponData,
                                                            eventId: this.eventData.id
                                                        }
                )
                if (response.data.remainingAmount > 0) {
                    this.addNewCoupon(response.data.couponId, response.data.remainingAmount)
                    this.resetFields()
                } else {
                    this.couponError = 'alreadyRedeemedCouponCode'
                }
            } catch (error) {
                if (error.response && error.response.data) {
                    if (error.response.data.message === "couponNotFound")
                        this.couponError = 'couponNotFound'
                    if (error.response.data.message === "couponIsIncompatibleWithEvent")
                        this.couponError = 'couponIsIncompatibleWithEvent'
                } else
                    console.error(error);
            }
        },
        addNewCoupon(couponId, remainingAmount) {
            this.$emit('newCoupon', {
                couponId: couponId,
                amount: remainingAmount,
                word1: this.couponData.word1,
                word2: this.couponData.word2,
                word3: this.couponData.word3
            })
        },
        resetFields() {
            this.couponData = {
                couponId: "",
                word1: "",
                word2: "",
                word3: ""
            }
            this.fillAllFieldsWarning = false
            this.couponError = null
        }
    }
}
</script>

<style lang="scss" scoped>
@use "sass:map";

.flex-gap-4 {
    gap: map.get($spacers, 4)
}

.flex-gap-2 {
    gap: map.get($spacers, 2)
}

</style>
